export default function LoadingSpinner({ size = 'md' }) {
  const sz = size === 'sm' ? '1.25rem' : size === 'lg' ? '3rem' : '2rem';
  return <div className="loading-spinner" style={{ width: sz, height: sz }} />;
}
